var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8337 9.75C13.8337 10.0594 13.7107 10.3562 13.492 10.575C13.2732 10.7937 12.9764 10.9167 12.667 10.9167H4.50033L2.16699 13.25V3.91667C2.16699 3.60725 2.28991 3.3105 2.5087 3.09171C2.72749 2.87292 3.02424 2.75 3.33366 2.75H12.667C12.9764 2.75 13.2732 2.87292 13.492 3.09171C13.7107 3.3105 13.8337 3.60725 13.8337 3.91667V9.75Z",
    stroke: "#898EA2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 7,
    r: 1,
    fill: "#898EA2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 1,
    fill: "#898EA2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 7,
    r: 1,
    fill: "#898EA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.1bc09801a443d726a0e34caa95c34bb5.svg";
export { ForwardRef as ReactComponent };